import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const createUserInviteRequestSchema = z.object({
  email: z.string().email(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  locationId: z.string().optional(),
  role: z.enum(['tenant-admin', 'tenant-member']).default('tenant-member'),
});

const resendUserInviteRequestSchema = z.object({
  inviteId: z.string(),
});

const revokeUserInviteRequestSchema = z.object({
  inviteId: z.string(),
});

export type CreateUserInviteRequest = z.infer<
  typeof createUserInviteRequestSchema
>;
export type ResendUserInviteRequest = z.infer<
  typeof resendUserInviteRequestSchema
>;
export type RevokeUserInviteRequest = z.infer<
  typeof revokeUserInviteRequestSchema
>;

export const tenantAdminUsersContract = c.router(
  {
    createInvite: {
      method: 'POST',
      path: '/create',
      responses: {
        200: z.object({ message: z.string() }),
      },
      body: createUserInviteRequestSchema,
      summary: 'Sends user invitiation to provided email',
    },
    resendInvite: {
      method: 'POST',
      path: '/resend',
      responses: {
        200: z.object({ message: z.string() }),
      },
      body: resendUserInviteRequestSchema,
      summary: 'Resends pending invitation email',
    },
    revokeInvite: {
      method: 'POST',
      path: '/revoke',
      responses: {
        200: z.object({ message: z.string() }),
      },
      body: revokeUserInviteRequestSchema,
      summary: 'Revokes pending invitation',
    },
  },
  {
    pathPrefix: '/:tenantId/user-invites',
  },
);
